import { render, staticRenderFns } from "./FollowingModal.vue?vue&type=template&id=6d3e2e8e&"
import script from "./FollowingModal.vue?vue&type=script&lang=js&"
export * from "./FollowingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports